const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .icon-edit-primary{fill:none;stroke:#008941;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}\n        "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.5 -0.318)"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-edit-primary",
  d: "M36.364,6H10.414A7.414,7.414,0,0,0,3,13.414v51.9a7.414,7.414,0,0,0,7.414,7.414h51.9a7.414,7.414,0,0,0,7.414-7.414V39.364",
  transform: "translate(0 4.682)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-edit-primary",
  d: "M50.924,5.121A7.864,7.864,0,0,1,62.045,16.242L26.828,51.46,12,55.167l3.707-14.828Z",
  transform: "translate(13.242 0)"
}));
function SvgIconfeatherEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.591,
    height: 79.591,
    viewBox: "0 0 79.591 79.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherEdit);
export default __webpack_public_path__ + "static/media/Icon feather-edit.c4ddfff0.svg";
export { ForwardRef as ReactComponent };